import { useTheme } from '@mui/material';
import { memo } from 'react';

interface MultiStoreDotProps {
  // sopra un giorno o un orario selezionato (sfondo primary) prende il colore del testo
  isInverted?: boolean;
  className?: string;
}

// Puntino «libero solo in altri centri», uguale su giorni, orari e legenda
export const MultiStoreDot = memo(function MultiStoreDot({
  isInverted = false,
  className,
}: MultiStoreDotProps): JSX.Element {
  const { palette } = useTheme();

  return (
    <span
      aria-hidden="true"
      className={
        className === undefined ? 'multi-store-dot' : `multi-store-dot ${className}`
      }
      style={{
        backgroundColor: isInverted
          ? palette.primary.contrastText
          : palette.primary.main,
      }}
    />
  );
});
